import { BudgetMessage } from '../../../../types/BudgetMessage';
import { Text } from '../../../cdl/Text/Text';
import { BudgetDonutChart } from '../../../common/BudgetDonutChart/BudgetDonutChart';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

import { BudgetCaption } from './BudgetCaption';
import { BudgetDonutChartDisplay } from './BudgetDonutChartDisplay';

interface BudgetInformationProps {
    budgetData: BudgetMessage;
}

export const BudgetInformation = (props: BudgetInformationProps) => {
    return (
        <div>
            <Box display="grid" gridTemplateColumns="minmax(0, 2fr) minmax(0, 3fr)" gap={16}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <BudgetDonutChart
                        spentBudget={props.budgetData.spentBudget.amount}
                        budget={props.budgetData.budget.amount}
                    >
                        <BudgetDonutChartDisplay budgetData={props.budgetData} />
                    </BudgetDonutChart>
                </Box>

                <Box display="flex" alignItems="center">
                    <BudgetCaption budgetData={props.budgetData} />
                </Box>
            </Box>

            <Text display="block" size={12} color="foreground.subtle" textAlign="right">
                {translate('budgets.budgetSpentInfo')}
            </Text>
        </div>
    );
};
